import React, { useState } from 'react';
import toast from 'react-hot-toast';
import {
  GoalContainer, GoalTextContainer, GoalWeeksContainer, Info, Item, Label, LabelContainer, Radio, RadioContainer, RadioInner, Title,
} from './styles';
import ModalButton from '../../components/ModalButton';
import { VirtualRaceStatesTypes } from '.';
import coreApi from '../../services/coreApi';
import { UserVirtualRaceType, VirtualRaceType } from '../../types/VirtualRace';

interface Props {
  action: () => void
  userVirtualRace: UserVirtualRaceType,
  virtualRace: VirtualRaceType,
  setUserVirtualRace: React.Dispatch<React.SetStateAction<UserVirtualRaceType | undefined>>
}

export default function VirtualRaceGoal({
  action, virtualRace, setUserVirtualRace, userVirtualRace,
}: Props) {
  const [distance, setDistance] = useState(0);

  const createVirtualRace = async () => {
    if (distance === 0) {
      toast.error('Selecione uma distância para continuar');
      return;
    }

    const data = {
      distance,
      status: VirtualRaceStatesTypes.IN_PROGRESS,
    };

    coreApi.put(`user-virtual-race/${userVirtualRace._id}`, data)
      .then((response) => {
        if (response.data) {
          setUserVirtualRace(response.data);
          action();
          toast.success('Prova virtual iniciada com sucesso!');
        }
      })
      .catch(() => {
        toast.error('Erro ao iniciar a prova virtual');
      });
  };

  return (
    <GoalContainer>
      <Title>Escolha a distância</Title>
      <GoalTextContainer>
        <Info>
          Escolha a distância que deseja completar na sua prova virtual.
        </Info>
      </GoalTextContainer>
      <GoalWeeksContainer>
        {virtualRace.distances.map((dist) => (
          <Item
            key={dist}
            onClick={() => setDistance(dist)}
            selected={distance === dist}
          >
            <RadioContainer>
              <Radio
                selected={distance === dist}
              >
                <RadioInner
                  selected={distance === dist}
                />
              </Radio>
            </RadioContainer>
            <LabelContainer>
              <Label>{`${dist} km`}</Label>
            </LabelContainer>
          </Item>
        ))}
      </GoalWeeksContainer>
      <ModalButton title="CONTINUAR" onPress={createVirtualRace} style={{ padding: 8, marginTop: 43, marginBottom: 33 }} />
    </GoalContainer>
  );
}
